import React from "react";
import banner from "../../assets/10_POSVENTA/1.webp";

/*eslint-disable */
interface DescriptionComponentProps {
  multicotizadorData: any;
}

declare const window: any;
const DescriptionComponent: React.FC<DescriptionComponentProps> = ({
  multicotizadorData
}) => {
  return (
    <div className="description-multi-cotizacion-component">
      <h1 className="title-description-multi-cotizacion-component">
        {multicotizadorData[0]?.title}
      </h1>
      <div className="text-description-multi-cotizacion-component">
      {multicotizadorData[0]?.description}
      </div>
    </div>
  );
};

export default DescriptionComponent;
